// Boundary-aware: /portal-admin is an internal page, not a supplier surface.
export const isSupplierPublicPath = (pathname) =>
  ["/portal", "/review"].some(path => pathname === path || pathname.startsWith(`${path}/`));